import { Button } from "./ui/button";
import catalogoRojoAmanecerImage from "@/assets/catalogo-rojo-amanecer.png";
import portadaCatalogo from "@/assets/portada_acervo_catalogo.png";


const documentosDestacados = [
  {
    id: 1,
    titulo: "Catálogo del Acervo Xavier Robles y Guadalupe Ortega",
    imagen: portadaCatalogo,
    alt: "Catálogo del Acervo Xavier Robles y Guadalupe Ortega - 50 años de vida en el cine",
    link: "https://drive.google.com/file/d/1pW8pHJVHUZ7iXu9XJylRDU8vcIw2tKh2/view?usp=sharing",
  },
  {
    id: 2,
    titulo: "Catálogo de la película Rojo Amanecer",
    imagen: catalogoRojoAmanecerImage,
    alt: "Catálogo de la película Rojo Amanecer - 50 años de vida en el cine",
    link: "https://drive.google.com/file/d/14k5HQcJqo9teVKfDA4iNMQOPFCB4pm5q/view?usp=sharing",
  },
];

const FeaturedContent = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-background to-muted/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-brand mb-4 tracking-tight">
            Contenido Destacado
          </h2>
          <div className="w-32 h-1 bg-gradient-to-r from-brand via-golden to-brand mx-auto rounded-full shadow-sm"></div>
        </div>

        <div className="flex flex-col gap-16">
          {documentosDestacados.map((documento) => (
            <div key={documento.id} className="flex flex-col items-center gap-6">
              <h3 className="text-2xl md:text-3xl font-cormorant italic text-foreground/80 text-center">
                {documento.titulo}
              </h3>

              <div className="max-w-4xl w-full mx-auto">
                <img
                  src={documento.imagen}
                  alt={documento.alt}
                  className="w-full h-auto rounded-xl shadow-lg border border-border"
                />
              </div>

              <div className="w-full flex justify-center mt-4">
                <Button
                  onClick={() => window.open(documento.link, "_blank")}
                  size="lg"
                  className="text-lg px-10 py-6 bg-golden hover:bg-brand text-golden-foreground hover:text-brand-foreground transition-all duration-300 shadow-md hover:shadow-lg"
                >
                  Visualizar
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedContent;
